import { render, staticRenderFns } from "./NotificationsSettings.vue?vue&type=template&id=2993edd0&scoped=true"
import script from "./NotificationsSettings.vue?vue&type=script&lang=js"
export * from "./NotificationsSettings.vue?vue&type=script&lang=js"
import style0 from "./NotificationsSettings.vue?vue&type=style&index=0&id=2993edd0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2993edd0",
  null
  
)

export default component.exports